import type { OcsSettingsName } from "settings-utils/lib/ocs/OcsSettingsName";

export const MAIL_CUSTOMIZED_HOVER_ACTION_VERSION: OcsSettingsName = "mail_customizedhoveractionversion";

export const HOVER_ACTION_VERSION = 2;
export const CUSTOM_HOVER_SIZE = 4;
